export const checkTemplateExists = (widgets) => {
    const templateExists = widgets.filter(widget => {return widget.templateId !== undefined})
    if(templateExists.length > 0){

        return [templateExists[0]]
    } else {
        return []
    }
}